import { useSelector } from "react-redux";

export const useDeckCards = () => useSelector((state) => state.deck.deck.cards);

export const useShowSuitTitleOnCards = () =>
  useSelector((state) => !!state.deck.deck.showSuitTitleOnCards);
